export default "/icons/typescript_icon.svg";